// extracted by mini-css-extract-plugin
export default {"scrollableArea":"single-recipe-steps_scrollableArea__Q1LGw","separator":"single-recipe-steps_separator___We3b","bpName":"single-recipe-steps_bpName__Ft474"};